/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiationSession from './radiation-session';
import RadiationSessionDetail from './radiation-session-detail';
import RadiationSessionUpdate from './radiation-session-update';
import RadiationSessionDeleteDialog from './radiation-session-delete-dialog';

const RadiationSessionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiationSession />} />
    <Route path="new" element={<RadiationSessionUpdate />} />
    <Route path=":id">
      <Route index element={<RadiationSessionDetail />} />
      <Route path="edit" element={<RadiationSessionUpdate />} />
      <Route path="delete" element={<RadiationSessionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiationSessionRoutes;
